module.exports = __webpack_public_path__ + "static/media/logoutIcon.a81967db.svg";